import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  getCurrentRightSideComponentInfo,
  getHelpNote
} from '@shared/components/platform-sidebar/store/platform-sidebar.selector';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {PopCurrentRightSideComponentAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";

@Component({
    standalone: false,
    selector: 'particle-help-notes',
  templateUrl: './help-notes.component.html',
  styleUrls: ['./help-notes.component.scss']
})
export class HelpNotesComponent implements OnInit, OnDestroy,AfterViewInit {
  unSubscribe$ = new Subject<void>();
  helpNoteItem:any;
  helpNoteList:any;
  isDivContent = false;
  divContent: string;
  constructor(private particleCacheService: ParticleCacheService,  private platformSidebarStore: Store<PlatformSidebarState>,) {

  }
  ngAfterViewInit (): void {

  }
  ngOnInit() {
    this.helpNoteList = this.particleCacheService.getItem('helpModels')?this.particleCacheService.getItem('helpModels'):[];
    this.helpNoteItem = {};
    this.helpNoteItem.notes = [];


    this.platformSidebarStore.select(getHelpNote).pipe(takeUntil(this.unSubscribe$)).subscribe((helpNote: any) => {
      this.helpNoteItem = {};
      this.helpNoteItem.notes = [];
      if(helpNote && helpNote.helpNoteDetails){
        this.helpNoteItem = {
          notes: helpNote.helpNoteDetails
        };
      }else if(helpNote && helpNote.helpNoteId){
        let helpNoteId = helpNote.helpNoteId;
        this.helpNoteList.forEach((x:any)=>{
          if(x.id==helpNoteId){
            this.helpNoteItem = x;
            if (x.fieldValues && x.fieldValues.IsDivContent === true) {
              this.isDivContent = x.fieldValues.IsDivContent;
              this.divContent = this.helpNoteItem.notes.join('\n');
            }
          }
        });
      } else {
        // closing details component
        this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction('HelpNotesComponent'));
      }
    });
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
